import { Observable } from './rxjs';

export const ajax = Observable.ajax;
export const get = Observable.ajax.get;
export const getJSON = Observable.ajax.getJSON;
export const post = Observable.ajax.post;
export const put = Observable.ajax.put;
export const doDelete = Observable.ajax.delete;
